//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "scoring-sup-list",
  data() {
    return {
      sourceId: null,
      schemeDetailId: null,
      scoreData: {}
    }
  },
  methods: {
    backLast() {
      this.$router.go(-1);
    },
    getScoreData() {
      this.$loadingShow();
      this.$get(`api/sourceRating/scoring/${this.sourceId}/${this.schemeDetailId}`).then((res) => {
        this.scoreData = res;
        this.$loadingHide();
      }).catch(() => {
        this.$loadingHide();
      });
    },
    viewOffer() {
      if (!this.scoreData.scoringSchemeDetail.enableViewSupAttachs) {
        this.$router.push(`/parity-offer/${this.scoreData.sourcing.sourceRoId}?hiddenAttach=true`);
      } else if (!this.scoreData.scoringSchemeDetail.enableViewPrice) {
        this.$router.push(`/parity-offer/${this.scoreData.sourcing.sourceRoId}?hiddenPrice=true&showAttach=${this.scoreData.scoringSchemeDetail.enableViewSupAttachs}`);
      } else {
        this.$router.push(`/parity-offer/${this.scoreData.sourcing.sourceRoId}?showAttach=${this.scoreData.scoringSchemeDetail.enableViewSupAttachs}`);
      }
    },
    changeScoreShow(sup) {
      if (sup.scoreShow) {
        this.$set(sup, 'scoreShow', false);
        return;
      }
      this.$set(sup, 'scoreShow', true);
    },
    goSupScore(supScore) {
      console.log(supScore);
      this.$router.push(`/source-scoring/sup-detail/${this.schemeDetailId}/${supScore.scoringObjectId}/${supScore.scoringDetailId}`);
    }
  },
  mounted() {
    this.sourceId = this.$route.params.sourceId;
    this.schemeDetailId = this.$route.params.detailId;
    this.getScoreData();
  }
}



// WEBPACK FOOTER //
// ./src/page/sources/source-score/scoring-sup-list.vue